export const MAT_NAME = 'mat';
export const MAT_COORDS_NAME = 'matCoords';

export const MAT_CONFIGS = {
    [MAT_NAME]: {
        id: MAT_NAME,
        gridSize: [10, 10],
        fieldSizeCm: 8,
        labels: { type: 'alpha-numeric' },
        hasCommands: true,
        hasAxisLines: true,
    },
    [MAT_COORDS_NAME]: {
        id: MAT_COORDS_NAME,
        gridSize: [10, 10],
        fieldSizeCm: 8,
        labels: { type: 'coordinate', range: [-5, 5] },
        hasCommands: false,
        hasAxisLines: true,
    },
};
